import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export function initMarketsSlider() {
  const slider = document.querySelector('.testimonials__slider');
  if (!slider) return;

  // Check if there's only one slide
  const slides = slider.querySelectorAll('.swiper-slide');
  const isSingleSlide = slides.length <= 1;

  // Get the image element - try multiple possible IDs
  const imageElement = document.getElementById('testimonials-image') || 
                       document.getElementById('markets-image') ||
                       slider.closest('.testimonials')?.querySelector('.testimonials__image img') ||
                       slider.closest('.markets__testimonials')?.querySelector('.markets__image img');

  // If only one slide, don't initialize Swiper to prevent blinking
  if (isSingleSlide) {
    // Make sure the single slide is visible
    if (slides[0]) {
      slides[0].style.opacity = '1';
    }
    return null;
  }

  const swiper = new Swiper(slider, {
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    speed: 600,
    centeredSlides: false,
    allowTouchMove: true,
    autoHeight: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: true,
      pauseOnMouseEnter: true,
    },

    // Navigation arrows
    navigation: {
      nextEl: '.testimonials__slider-pagination-next',
      prevEl: '.testimonials__slider-pagination-prev',
    },

    // Custom pagination
    pagination: {
      el: '.testimonials__slider-pagination-number',
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        const currentFormatted = String(current).padStart(2, '0');
        // const totalFormatted = String(total).padStart(2, '0');
        return `<span class="swiper-pagination-current">${currentFormatted}</span>`;
      }
    },

    // Events
    on: {
      slideChange: function () {
        // Update the custom pagination display
        const currentFormatted = String(this.realIndex + 1).padStart(2, '0');
        const paginationEl = document.querySelector('.testimonials__slider-pagination-number');
        if (paginationEl) {
          paginationEl.innerHTML = `<span class="swiper-pagination-current">${currentFormatted}</span>`;
        }

        // Update the image from the active slide's data attribute
        if (imageElement) {
          // Find the slide with the matching data-index
          const activeSlide = Array.from(this.slides).find(slide => 
            parseInt(slide.dataset.index) === this.realIndex
          );
          
          // console.log('Real Index:', this.realIndex);
          // console.log('Active Slide:', activeSlide);
          // console.log('Image Source:', activeSlide?.dataset.image);
          
          if (activeSlide) {
            const newImageSrc = activeSlide.dataset.image;
            
            if (newImageSrc) {
              // Add fade transition
              imageElement.style.opacity = '0';
              
              setTimeout(() => {
                imageElement.src = newImageSrc;
                imageElement.style.opacity = '1';
              }, 150);
            }
          }
        }
      }
    }
  });

  return swiper;
}
